import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';

const VisaStatusBadge = ({ status, size = 'default' }) => {
  const { t } = useLanguage();

  const statusConfig = {
    pending: {
      label: t('common.pending'),
      color: 'bg-warning/10 text-warning border-warning/20'
    },
    in_review: {
      label: t('visas.underReview'),
      color: 'bg-primary/10 text-primary border-primary/20'
    },
    approved: {
      label: t('visas.approved'),
      color: 'bg-success/10 text-success border-success/20'
    },
    rejected: {
      label: t('visas.rejected'),
      color: 'bg-destructive/10 text-destructive border-destructive/20'
    },
    expired: {
      label: t('visas.expired'),
      color: 'bg-muted text-muted-foreground border-border'
    },
    issued: {
      label: t('visas.issued'),
      color: 'bg-accent/10 text-accent border-accent/20'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.pending;
  const sizeClasses = size === 'sm' ? 'text-xs px-2 py-1' : 'text-sm px-3 py-1.5';

  return (
    <span className={`inline-flex items-center justify-center rounded-md border font-medium ${config?.color} ${sizeClasses}`}>
      {config?.label}
    </span>
  );
};

export default VisaStatusBadge;